import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const PastDateValidator = z.literal('pastDate');
export type TPastDateValidator = z.infer<typeof PastDateValidator>;

export const PastDateValidatorParamsSchema = z.object({});

export type TPastDateValidatorParams = z.infer<typeof PastDateValidatorParamsSchema>;

export const PastDateValidatorSchema = BaseValidatorSchema.extend({
  type: PastDateValidator,
  value: PastDateValidatorParamsSchema.optional(),
});
